// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jd-details {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    margin-left: 100px;
}

.details {
    width: 100%;
    max-width: 800px;
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
   
}


.loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  
}

.table{
    width:500px;
    margin: 10px;
    padding: 10px 20px;
    font-size: 16px;
    border-radius: 5px;
    justify-content: center;
    margin-left: 600px;
    border: 1px solid black;  
    
}`, "",{"version":3,"sources":["webpack://./src/styles/JDDetails.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,mBAAmB;;AAEvB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;;AAEjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;;AAE3B","sourcesContent":[".jd-details {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 50px;\n    margin-left: 100px;\n}\n\n.details {\n    width: 100%;\n    max-width: 800px;\n    background-color: #f8f9fa;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    margin-bottom: 20px;\n   \n}\n\n\n.loader {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n  \n}\n\n.table{\n    width:500px;\n    margin: 10px;\n    padding: 10px 20px;\n    font-size: 16px;\n    border-radius: 5px;\n    justify-content: center;\n    margin-left: 600px;\n    border: 1px solid black;  \n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
